import { Link } from 'react-router-dom';

import classes from './Footer.module.scss';
import LinkedIn from '../../assets/icons/linkedin.svg'
import Facebook from '../../assets/icons/facebook.svg'
import Instagram from '../../assets/icons/instagram.svg'
import Twitter from '../../assets/icons/twitter.svg'
import LogoBg from '../../assets/LogoWithoutBackground.png';
import { COMPANY_ADDRESS, SOCIAL_LINKS, SUPPORT_EMAIL } from '../../siteConfig';

const FOOTER_COLUMNS = [
    {
        title: 'Need Help',
        links: [
            { label: 'Contact Us', to: '/contact-us' },
            { label: 'Track Order', to: '/track-order' },
            { label: 'Returns & Refunds', to: '/returns-and-refunds' },
            { label: "FAQ's", to: '/faq' },
            { label: 'Career', to: '/careers' },
        ],
    },
    {
        title: 'Company',
        links: [
            { label: 'About Us', to: '/about-us' },
            { label: 'Our Mission', to: '/mission' },
            { label: 'Our Vision', to: '/vision' },
            { label: 'Collaboration', to: '/collaboration' },
            { label: 'Media', to: '/media' },
        ],
    },
    {
        title: 'More Info',
        links: [
            { label: 'Term and Conditions', to: '/terms-and-conditions' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
            { label: 'Shipping Policy', to: '/shipping-policy' },
            { label: 'Sitemap', to: '/sitemap' },
        ],
    },
];

const SOCIAL_ICONS = [
    { name: 'facebook', icon: Facebook, href: SOCIAL_LINKS.facebook },
    { name: 'instagram', icon: Instagram, href: SOCIAL_LINKS.instagram },
    { name: 'twitter', icon: Twitter, href: SOCIAL_LINKS.twitter },
    { name: 'linkedin', icon: LinkedIn, href: SOCIAL_LINKS.linkedin },
];

export default function Footer() {
    return (
        <div className={classes.FooterContainer}>
            <div className={classes.div}>
                <div className={classes.div2}>
                    <img src={LogoBg} className={classes.footerImage} alt='logo' />
                    <div className={classes.footerDescription}>
                        Abayatique brings together abaya designers and sellers from across the UAE
                        and the Gulf in one place — and every order can be customised to your
                        measurements, fabric and finish.
                    </div>
                    <div className={classes.div29}>
                        {SOCIAL_ICONS.map((social) => (
                            <a
                                key={social.name}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={social.name}
                            >
                                <img alt={social.name} src={social.icon} className={classes.img} />
                            </a>
                        ))}
                    </div>
                </div>
                <div className={classes.div4}>
                    {FOOTER_COLUMNS.map((column) => (
                        <div key={column.title} className={classes.column}>
                            <div className={classes.div5}>
                                <div className={classes.footerTitle}>{column.title}</div>
                                {column.links.map((link) => (
                                    <Link key={link.to} to={link.to} className={classes.footerLink}>
                                        {link.label}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                    <div className={classes.column}>
                        <div className={classes.div5}>
                            <div className={classes.footerTitle}>Location</div>
                            <a href={`mailto:${SUPPORT_EMAIL}`} className={classes.footerLink}>
                                {SUPPORT_EMAIL}
                            </a>
                            <div className={classes.footerLink}>{COMPANY_ADDRESS}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.div31} />
            <div className={classes.div34}>
                Copyright © {new Date().getFullYear()} Abayatique. All rights reserved.
            </div>
        </div>
    )

}
